import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import fetchData from '../../api/fetchApi';

export default function ViewBlogPage() {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadBlog() {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchData(`admin/blog/${uuid}`);
        setBlog(res);
      } catch (e) {
        setError('فشل في جلب المقال');
      } finally {
        setLoading(false);
      }
    }
    if (uuid) loadBlog();
  }, [uuid]);

  if (loading) return <div className="p-8 text-center text-gray-500">جاري التحميل...</div>;
  if (error) return <div className="p-8 text-center text-red-600">{error}</div>;
  if (!blog) return null;

  return (
    <div className="p-6 mt-8" dir="rtl">
      <button onClick={() => navigate(-1)} className="mb-4 text-gray-500 hover:text-red-600">عودة</button>
      <h1 className="text-2xl font-bold text-[#1D2035] mb-2">{blog.title}</h1>
      <div className="text-gray-500 text-sm mb-4">{blog.created ? blog.created.slice(0, 10) : ''}</div>
      <div className="prose prose-lg mb-6" dangerouslySetInnerHTML={{ __html: blog.body || '' }} />
      {Array.isArray(blog.files) && blog.files.length > 0 && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">الملفات المرفقة:</h3>
          <div className="flex flex-wrap gap-3">
            {blog.files.map((f, idx) => (
              <a key={f.uuid || idx} href={f.url} target="_blank" rel="noopener noreferrer" className="block border rounded p-2 text-blue-700 hover:bg-gray-50">
                {f.thumbnail_url ? (
                  <img src={f.thumbnail_url} alt={f.name} className="w-20 h-20 object-cover rounded mb-1" />
                ) : null}
                <div className="truncate w-20 text-xs">{f.name || f.url}</div>
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
